import {PartnerPersonModel} from '../entity/partnerPerson.model';
import {HttpModelConverter} from '../../../../../core/converter/httpModel.converter';
import {PartnerSummaryConverter} from '../../../../common/api/converter/partnerSummary.converter';
import {PartnerPersonSummaryConverter} from './partnerPersonSummary.converter';
import {Injectable} from '@angular/core';
import {AddressConverter} from "../../../../../common/converter/address.converter";

@Injectable({
    providedIn: 'root'
})
export class PartnerPersonConverter extends HttpModelConverter<PartnerPersonModel>{

    constructor(private partnerSummaryConverter: PartnerSummaryConverter,
                private partnerPersonSummaryConverter: PartnerPersonSummaryConverter,
                private addressConverter: AddressConverter) {
        super();
    }
    protected createInstance(): PartnerPersonModel {
        return new PartnerPersonModel();
    }

    protected enrichObject(result: PartnerPersonModel, src: PartnerPersonModel) {
        result.partner = this.partnerSummaryConverter.convert(src.partner);
        result.summary = this.partnerPersonSummaryConverter.convert(src.summary);
        result.mainAddress = this.addressConverter.convert(src.mainAddress);
    }
}
